import * as React from 'react';

/**
 * @see {@link https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state}
 */
export function usePrevious<T>(value: T): React.MutableRefObject<T | undefined>['current'] {
    const ref = React.useRef<T>(undefined);
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
